// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%278%27 viewBox=%270 0 12 8%27 fill=%27none%27%3E%3Cpath d=%27M10 2L6.70707 5.2929C6.31818 5.68179 5.68182 5.68179 5.29293 5.2929L2 2%27 stroke=%27%23003DA5%27 stroke-miterlimit=%2710%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%278%27 viewBox=%270 0 12 8%27 fill=%27none%27%3E%3Cpath d=%27M2 6L5.29293 2.7071C5.68182 2.31821 6.31818 2.31821 6.70707 2.7071L10 6%27 stroke=%27white%27 stroke-miterlimit=%2710%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-confirm-popup {
  position: absolute;
  top: 12% !important;
  left: 0% !important;
}

.hide-popup {
  pointer-events: none;
}

.show-popup {
  cursor: pointer;
}

.pmp-comment-buttons {
  position: relative;
  top: -2px;
  display: flex;
  gap: 1.75rem;
  align-items: center;
  justify-content: flex-start;
}

.pmp-comment-input {
  width: 100% !important;
  min-width: 200px !important;
  padding: 0.375rem 0.5rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  font-size: 0.875rem;
}
.pmp-comment-input:focus {
  outline: none;
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.pmp-comment-input::placeholder {
  color: #6c757d;
  opacity: 1;
}

.p-datepicker table td {
  padding: 0.2px !important;
}

.p-button:focus {
  box-shadow: none !important;
}

.snapshot-icons {
  display: inline-block;
}

.fullkit-dialog {
  width: auto;
  min-width: 60rem;
  height: 597px;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.12);
}
.fullkit-dialog .header-dialog {
  color: var(--Primary-color, #003da5);
  font-family: Montserrat;
  font-size: 20px;
  font-style: normal;
  line-height: normal;
}
.fullkit-dialog .p-datatable {
  overflow: auto !important;
}
.fullkit-dialog .p-datatable .p-datatable-wrapper {
  width: 100%;
  overflow: hidden !important;
}
.fullkit-dialog .p-datatable .p-datatable-tbody > tr > td:first-child {
  overflow-wrap: break-word;
  white-space: normal;
  word-break: break-all;
}

.artworkStatus {
  overflow: hidden;
  height: 100%;
}
.artworkStatus .flex-display {
  display: flex;
}
.artworkStatus tr {
  height: 36px !important;
}
.artworkStatus td,
.artworkStatus th {
  min-width: 140px;
  max-width: 200px;
}
.artworkStatus .p-paginator {
  position: fixed;
  bottom: 1%;
  right: 1%;
  border: 0;
  border-radius: 10px;
  z-index: 100;
  background: transparent;
}
.artworkStatus .cic-tooltip-target {
  display: flex;
  justify-content: center;
}
.artworkStatus table thead th {
  background-color: #edf4fa !important;
  height: 30px;
  border-width: 1px 2px 3px 4px;
  padding: 0 !important;
  word-wrap: initial;
}
.artworkStatus table thead th:nth-child(1) {
  border-left: none !important;
}
.artworkStatus table thead th:last-child {
  border-left: none !important;
}
.artworkStatus table thead th.p-filter-column .p-column-filter .p-fluid {
  min-width: 100px;
  border-radius: 140px;
  background-color: #ffffff !important;
}
.artworkStatus table thead .p-filter-column {
  background-color: #ffffff !important;
  padding: 10px !important;
}
.artworkStatus table .p-datatable .p-datatable-tbody > tr {
  line-height: 50px !important;
  font-size: 12px;
}
.artworkStatus table td,
.artworkStatus table .p-datatable .p-datatable-tbody > tr > td {
  border-bottom: 0.5px solid #acacac !important;
  font-size: 12px;
  color: #595959;
  background: #ffffff !important;
  padding: 0 7px !important;
}
.artworkStatus table td:first-child,
.artworkStatus table .p-datatable .p-datatable-tbody > tr > td:first-child {
  border-left: none !important;
}
.artworkStatus table td:last-child,
.artworkStatus table .p-datatable .p-datatable-tbody > tr > td:last-child {
  border-right: none !important;
}
.artworkStatus table td .active-status,
.artworkStatus table .p-datatable .p-datatable-tbody > tr > td .active-status {
  background-color: #dfebff;
  color: #003da5;
}
.artworkStatus table td .not-started-status,
.artworkStatus table .p-datatable .p-datatable-tbody > tr > td .not-started-status {
  background-color: #f1f1f1;
  color: #595959;
}
.artworkStatus table td .completed-status,
.artworkStatus table .p-datatable .p-datatable-tbody > tr > td .completed-status {
  background-color: #e6ffe8;
  color: #006f05;
}
.artworkStatus table .p-inputtext {
  border-radius: 50px;
}
.artworkStatus .actions {
  padding-left: 20px;
}
.artworkStatus .p-datatable .p-datatable-footer {
  background: white;
  border: 0;
  border-width: 0;
  padding: 1rem 1rem;
  font-weight: 300;
  padding: 0;
}
.artworkStatus .artWorkStatusFooter-class {
  width: 100%;
}
.artworkStatus .artWorkStatusFooter-class ::-webkit-scrollbar {
  width: 0px !important;
  height: 0%;
  background: transparent;
}
.artworkStatus .p-datatable > .p-datatable-wrapper {
  overflow: auto;
  height: calc(100% - 140px);
  width: 100%;
}
@media only screen and (max-width: 1024px) {
  .artworkStatus .p-datatable > .p-datatable-wrapper {
    height: calc(100% - 200px);
  }
}
.artworkStatus #special-project > .p-datatable-wrapper {
  overflow: auto;
  height: calc(100% - 100px);
  width: 100%;
}
@media only screen and (max-width: 1024px) {
  .artworkStatus #special-project > .p-datatable-wrapper {
    height: calc(100% - 200px);
  }
}
.artworkStatus .p-datatable-scrollable-body {
  overflow: auto;
  /* This is to hide the default DataTable scrollbar */
}
.artworkStatus .p-datatable-table {
  line-height: 12px;
  width: 122%;
}
.artworkStatus .p-column-title {
  font-weight: 400;
}
.artworkStatus .p-column-title span {
  font-size: 12px;
  margin-left: 2px;
  align-items: center;
}
.artworkStatus .p-datatable-tbody {
  font-weight: 400;
}
.artworkStatus td,
.artworkStatus table .p-datatable .p-datatable-tbody > tr > td,
.artworkStatus th,
.artworkStatus tr {
  position: relative;
}
.artworkStatus.dsbp-wrapper .p-datatable {
  height: calc(100% - 220px);
}

.font-bold {
  font-weight: 700;
}

.p-checkbox {
  margin: 8px 8px 8px 8px;
}

.p-checkbox-checked + label {
  color: #003da5;
}

.ml-2 {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
}

img[disabled] {
  opacity: 0.5;
  cursor: no-drop;
}

.clearAllFilterMainDiv {
  display: flex;
  padding: 10.56px 22px 22px 2px;
}

.clearAllFilterDiv {
  line-height: 12px;
  justify-items: end;
  display: flex;
  position: absolute;
  right: 22px;
  top: 18px;
}

.clearAllFilter {
  cursor: pointer;
}

.clearAllFilterIcon {
  cursor: pointer;
  position: absolute;
  right: 5px;
}

.sortAndFrozen {
  padding: 0 22px 22px 2px;
  cursor: pointer;
  line-height: 12px;
}

.multiSelect {
  cursor: pointer;
  line-height: 10px;
}
.multiSelect .p-placeholder {
  color: #595959 !important;
}
.multiSelect .p-multiselect {
  width: 124px !important;
}

.p-overlaypanel {
  position: absolute !important;
}

.p-multiselect-item {
  text-wrap: wrap;
  font-size: 10px !important;
  line-height: 12px !important;
  padding: 0px 0 !important;
}

.p-inputtext {
  font-size: 10px !important;
  line-height: 12px !important;
  font-family: Montserrat !important;
}

.action-button {
  border-radius: 20px;
  box-shadow: 0 0 0 1px #003da5;
}

.p-dropdown-item:hover {
  background-color: #edf4fa !important;
}

div.actions-right {
  display: flex;
  flex-direction: row;
}
div.actions-right:nth-child(2) {
  margin-left: 12px;
}

.justify-content-center,
.justify-content-center1 {
  border: none;
}

.justify-content-center1 {
  margin-left: 15px;
}

div.p-button.p-component:nth-child(1) {
  border-radius: 12px 0 0 12px;
}

div.p-button.p-component:nth-child(2) {
  background-color: #acacac !important;
  color: white !important;
  border-radius: 0 12px 12px 0;
}

div.p-selectbutton.p-buttonset.p-component {
  border: none;
}

.p-selectbutton .p-button.p-highlight {
  border-color: grey !important;
}

.p-selectbutton .p-button {
  border-color: grey;
}

.apply-filter-text {
  color: "#003DA5" !important;
}

.filter-color-change {
  filter: invert(10%) sepia(100%) saturate(1200%) hue-rotate(204deg) brightness(60%) contrast(135%);
}

.checkbox-columnnames {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.checkbox-columnnames label {
  margin-bottom: 0px;
  margin-top: 3px;
}

.clearfix::after {
  content: "";
  display: table;
  clear: both;
}

#tasksActions {
  background: #003da5;
  font-size: 12px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 20px;
  border: 0;
  margin: 0;
}

.dropdown {
  background: transparent;
  font-size: 12px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 20px;
  border: 0;
}
.dropdown:focus-visible {
  outline: none;
}

.dropdown-item, .artwork-dsbp .dropdown-item {
  font-size: 12px;
  padding: 11px 16px;
  color: #595959;
}
.dropdown-item:hover:last-child {
  border-radius: 0 0 8px 8px;
}
.dropdown-item:hover:first-child {
  border-radius: 8px 8px 0 0;
}
.dropdown-item.active, .dropdown-item:hover {
  background: #edf4fa !important;
  color: #003da5;
}
.dropdown-item:focus {
  outline: none;
}

.artwork-dsbp .dropdown-item.active, .artwork-dsbp .dropdown-item:hover {
  background: #edf4fa !important;
  color: #003da5;
}

.dropdown-menu {
  padding: 0;
}

#tasksInActive {
  background-color: #fff !important;
  border-color: #003da5 !important;
  color: #003da5 !important;
  opacity: 1;
}

.dropdown-button-custom #tasksInActive::after {
  content: "";
  display: inline-block;
  width: 12px;
  height: 8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
  border: 0;
}

.dropdown-button-custom .btn[aria-expanded=true]::after,
.dropdown-button-custom .btn[aria-expanded=false]::after {
  content: "";
  display: inline-block;
  width: 12px;
  height: 8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: contain;
  border: 0;
  transform: rotate(0deg);
}

.dropdown-button-custom .btn[aria-expanded=false]::after {
  transform: rotate(180deg);
}

.footerIcons {
  tab-size: 10px;
  color: #818085;
  position: relative;
  background: #ffffff;
  left: 0;
  display: flex;
  border-top: 1px solid black;
}
.footerIcons .pi-times {
  position: relative !important;
  width: 14px;
  height: 14px;
  right: 0 !important;
  top: 0 !important;
  cursor: auto !important;
}

.recordfooter {
  display: flex;
  justify-content: space-between;
  margin-left: 10px;
  margin-right: 10px;
}

.footerIcon {
  display: flex;
  flex-direction: row;
}

.footIcon {
  border-left: 1px solid;
  padding-left: 4px;
}
.footIcon:first-child {
  border-left: unset;
}

.footerIconAll {
  font-size: 16px;
}

.footerIconsMain {
  display: flex;
  align-items: center;
}
.footerIconsMain:first-child {
  margin-left: 0;
}

.footerIcons2 {
  color: #ff0000;
  rotate: 180deg;
}

.footerIcons3 {
  color: #01ff1a;
}

.footerIcons4 {
  color: #ff0000;
  margin-right: 10px;
}

.footerIcons5 {
  color: #01ff1a;
}

.footerIcons6 {
  color: red;
}

.footerIcons7 {
  color: gray;
}

.footerIcons8 {
  color: #01ff1a;
}

.footerIcons9 {
  color: #ff0000;
}

.footerIcons10 {
  font-weight: bold;
  color: black;
}

.footerIcons11 {
  font-weight: bold;
  color: black;
}

.footerIconsContent1 {
  font-weight: 500;
  line-height: 12.19px;
  padding: 0 5px;
  margin: 0px 4px 0px 4px;
  font-size: 8px;
  color: black;
}

.pi pi-circle-off {
  font-size: 16px;
  margin-top: 10px;
}

.col-header {
  text-align: center !important;
  color: #003da5 !important;
  background: #edf4fa !important;
}`, "",{"version":3,"sources":["webpack://./src/components/ArtworkStatus/index.scss"],"names":[],"mappings":"AAIA;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;AAHF;;AAKA;EACE,oBAAA;AAFF;;AAIA;EACE,eAAA;AADF;;AAKA;EACE,kBAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;AAFF;;AAKA;EACE,sBAAA;EACA,2BAAA;EACA,wBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;AAFF;AAIE;EACE,aAAA;EACA,qBAAA;EACA,gDAAA;AAFJ;AAKE;EACE,cAAA;EACA,UAAA;AAHJ;;AAQA;EACE,yBAAA;AALF;;AAQA;EACE,2BAAA;AALF;;AAQA;EACE,qBAAA;AALF;;AAQA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gDAAA;AALF;AAOE;EACE,oCAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AALJ;AAOE;EACE,yBAAA;AALJ;AAOI;EACA,WAAA;EACA,2BAAA;AALJ;AAQE;EACE,yBAAA;EACA,mBAAA;EACA,qBAAA;AANJ;;AAUA;EACE,gBAAA;EACA,YAAA;AAPF;AASE;EACE,aAAA;AAPJ;AAUE;EACE,uBAAA;AARJ;AAWE;;EAEE,gBAAA;EACA,gBAAA;AATJ;AAWE;EACE,eAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;AATJ;AAYE;EACE,aAAA;EACA,uBAAA;AAVJ;AAeM;EACE,oCAAA;EACA,YAAA;EACA,6BAAA;EAEA,qBAAA;EACA,kBAAA;AAdR;AAgBQ;EACE,4BAAA;AAdV;AAiBQ;EACE,4BAAA;AAfV;AAmBM;EACE,gBAAA;EACA,oBAAA;EACA,oCAAA;AAjBR;AAoBM;EACE,oCAAA;EACA,wBAAA;AAlBR;AA0BI;EACE,4BAAA;EACA,eAAA;AAxBN;AA2BI;;EAEE,6CAAA;EACA,eAAA;EACA,cAAA;EACA,8BAAA;EACA,yBAAA;AAzBN;AA4BM;;EACE,4BAAA;AAzBR;AA4BM;;EACE,6BAAA;AAzBR;AA4BM;;EACE,yBAAA;EACA,cAAA;AAzBR;AA4BM;;EACE,yBAAA;EACA,cAAA;AAzBR;AA4BM;;EACE,yBAAA;EACA,cAAA;AAzBR;AA6BI;EACE,mBAAA;AA3BN;AA+BE;EACE,kBAAA;AA7BJ;AAgCE;EACE,iBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AA9BJ;AAiCE;EAEE,WAAA;AAhCJ;AAmCE;EACE,qBAAA;EACA,UAAA;EACA,uBAAA;AAjCJ;AAoCE;EACE,cAAA;EACA,0BAAA;EACA,WAAA;AAlCJ;AAoCI;EALF;IAMI,0BAAA;EAjCJ;AACF;AAoCE;EACE,cAAA;EACA,0BAAA;EACA,WAAA;AAlCJ;AAoCI;EALF;IAMI,0BAAA;EAjCJ;AACF;AAoCE;EACE,cAAA;EACA,oDAAA;AAlCJ;AAqCE;EACE,iBAAA;EACA,WAAA;AAnCJ;AAsCE;EACE,gBA5PY;AAwNhB;AAsCI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AApCN;AAwCE;EACE,gBAtQY;AAgOhB;AAqDE;;;;EAIE,kBAAA;AAnDJ;AAwDI;EACE,0BAAA;AAtDN;;AA2DA;EACE,gBAAA;AAxDF;;AA2DA;EACE,uBAAA;AAxDF;;AA2DA;EACE,cAAA;AAxDF;;AA2DA;EACE,gBAjTc;EAkTd,eAAA;EACA,iBAAA;AAxDF;;AA4DA;EACE,YAAA;EACA,eAAA;AAzDF;;AA+DA;EACE,aAAA;EACA,8BAAA;AA5DF;;AA+DA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AA5DF;;AA+DA;EACE,eAAA;AA5DF;;AA+DA;EACE,eAAA;EACA,kBAAA;EACA,UAAA;AA5DF;;AA+DA;EACE,wBAAA;EACA,eAAA;EACA,iBAAA;AA5DF;;AA+DA;EACE,eAAA;EACA,iBAAA;AA5DF;AA8DE;EACE,yBAAA;AA5DJ;AA+DE;EACE,uBAAA;AA7DJ;;AAiEA;EACE,6BAAA;AA9DF;;AAiEA;EACE,eAAA;EACA,0BAAA;EACA,4BAAA;EACA,yBAAA;AA9DF;;AAiEA;EACE,0BAAA;EACA,4BAAA;EACA,kCAAA;AA9DF;;AAkEA;EACE,mBAAA;EACA,6BAAA;AA/DF;;AAkEA;EACE,oCAAA;AA/DF;;AAkEA;EACE,aAAA;EACA,mBAAA;AA/DF;AAiEE;EACE,iBAAA;AA/DJ;;AAmEA;;EAEE,YAAA;AAhEF;;AAmEA;EACE,iBAAA;AAhEF;;AAmEA;EACE,4BAAA;AAhEF;;AAmEA;EACE,oCAAA;EACA,uBAAA;EACA,4BAAA;AAhEF;;AAmEA;EACE,YAAA;AAhEF;;AAmEA;EACE,6BAAA;AAhEF;;AAmEA;EACE,kBAAA;AAhEF;;AAmEA;EACE,2BAAA;AAhEF;;AAmEA;EACE,iGAAA;AAhEF;;AAmEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAhEF;AAkEE;EACE,kBAAA;EACA,eAAA;AAhEJ;;AAoEA;EACE,WAAA;EACA,cAAA;EACA,WAAA;AAjEF;;AAoEA;EACE,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;AAjEF;;AAoEA;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,SAAA;AAjEF;AAmEE;EACE,aAAA;AAjEJ;;AAqEA;EACE,eAAA;EACA,kBAAA;EACA,cAAA;AAlEF;AAoEE;EACE,0BAAA;AAlEJ;AAqEE;EACE,0BAAA;AAnEJ;AAsEE;EAEE,8BAAA;EACA,cAAA;AArEJ;AAwEE;EACE,aAAA;AAtEJ;;AA8EI;EAEE,8BAAA;EACA,cAAA;AA5EN;;AAiFA;EACE,UAAA;AA9EF;;AAiFA;EACE,iCAAA;EACA,gCAAA;EACA,yBAAA;EACA,UAAA;AA9EF;;AAiFA;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,wBAAA;EACA,SAAA;AA9EF;;AAiFA;;EAEE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,wBAAA;EACA,SAAA;EACA,uBAAA;AA9EF;;AAiFA;EACE,yBAAA;AA9EF;;AAiFA;EACE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,OAAA;EACA,aAAA;EACA,2BAAA;AA9EF;AAgFE;EACE,6BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;AA9EJ;;AAmFA;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;AAhFF;;AAmFA;EACE,aAAA;EACA,mBAAA;AAhFF;;AAmFA;EACE,sBAAA;EACA,iBAAA;AAhFF;AAiFE;EACE,kBAAA;AA/EJ;;AAmFA;EACE,eAAA;AAhFF;;AAmFA;EACE,aAAA;EACA,mBAAA;AAhFF;AAkFE;EACE,cAAA;AAhFJ;;AAoFA;EACE,cAAA;EACA,cAAA;AAjFF;;AAoFA;EACE,cAAA;AAjFF;;AAoFA;EACE,cAAA;EACA,kBAAA;AAjFF;;AAoFA;EACE,cAAA;AAjFF;;AAoFA;EACE,UAAA;AAjFF;;AAoFA;EACE,WAAA;AAjFF;;AAoFA;EACE,cAAA;AAjFF;;AAoFA;EACE,cAAA;AAjFF;;AAoFA;EACE,iBAAA;EACA,YAAA;AAjFF;;AAoFA;EACE,iBAAA;EACA,YAAA;AAjFF;;AAoFA;EACE,gBAAA;EACA,oBAAA;EACA,cAAA;EACA,uBAAA;EAEA,cAAA;EACA,YAAA;AAlFF;;AAqFA;EACE,eAAA;EACA,gBAAA;AAlFF;;AAwFA;EACE,6BAAA;EACA,yBAAA;EACA,8BAAA;AArFF","sourcesContent":["$width100: 100%;\n$fontWeight500: 500;\n$fontWeight400: 400;\n\n.p-confirm-popup {\n  position: absolute;\n  top: 12% !important;\n  left: 0% !important;\n}\n.hide-popup{\n  pointer-events: none;\n}\n.show-popup{\n  cursor: pointer;\n}\n\n// PMP Status Comment Styles\n.pmp-comment-buttons {\n  position: relative;\n  top: -2px;\n  display: flex;\n  gap: 1.75rem;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.pmp-comment-input {\n  width: 100% !important;\n  min-width: 200px !important;\n  padding: 0.375rem 0.5rem;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  font-size: 0.875rem;\n  \n  &:focus {\n    outline: none;\n    border-color: #80bdff;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n  }\n  \n  &::placeholder {\n    color: #6c757d;\n    opacity: 1;\n  }\n}\n\n// Datepicker for ProjectSetUp component Style Start\n.p-datepicker table td {\n  padding: 0.2px !important;\n}\n\n.p-button:focus {\n  box-shadow: none !important;\n}\n\n.snapshot-icons {\n  display: inline-block;\n}\n// Datepicker for ProjectSetUp component Style End\n.fullkit-dialog {\n  width:auto;\n  min-width: 60rem;\n  height: 597px;\n  border-radius: 20px;\n  background: #fff;\n  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.12);\n\n  .header-dialog {\n    color: var(--Primary-color, #003da5);\n    font-family: Montserrat;\n    font-size: 20px;\n    font-style: normal;\n    line-height: normal;\n  }\n  .p-datatable { \n    overflow: auto !important;\n\n    .p-datatable-wrapper {\n    width: 100%;\n    overflow: hidden !important; \n    }\n  }\n  .p-datatable .p-datatable-tbody > tr > td:first-child {\n    overflow-wrap: break-word;\n    white-space: normal;\n    word-break: break-all;\n  }\n}\n\n.artworkStatus {\n  overflow: hidden;\n  height: 100%;\n\n  .flex-display {\n    display: flex;\n  }\n\n  tr {\n    height: 36px !important;\n  }\n\n  td,\n  th {\n    min-width: 140px;\n    max-width: 200px;\n  }\n  .p-paginator {\n    position: fixed;\n    bottom: 1%;\n    right: 1%;\n    border: 0;\n    border-radius: 10px;\n    z-index: 100;\n    background: transparent;\n  }\n\n  .cic-tooltip-target {\n    display: flex;\n    justify-content: center;\n  }\n\n  table {\n    thead {\n      th {\n        background-color: #edf4fa !important;\n        height: 30px;\n        border-width: 1px 2px 3px 4px;\n        // border: 0 !important;\n        padding: 0 !important;\n        word-wrap: initial;\n\n        &:nth-child(1) {\n          border-left: none !important;\n        }\n\n        &:last-child {\n          border-left: none !important;\n        }\n      }\n\n      th.p-filter-column .p-column-filter .p-fluid {\n        min-width: 100px;\n        border-radius: 140px;\n        background-color: #ffffff !important;\n      }\n\n      .p-filter-column {\n        background-color: #ffffff !important;\n        padding: 10px !important;\n      }\n    }\n\n    // tr:nth-child(even)>td {\n    //   background: #fafcff !important;\n    // }\n\n    .p-datatable .p-datatable-tbody > tr {\n      line-height: 50px !important;\n      font-size: 12px;\n    }\n\n    td,\n    .p-datatable .p-datatable-tbody > tr > td {\n      border-bottom: 0.5px solid #acacac !important;\n      font-size: 12px;\n      color: #595959;\n      background: #ffffff !important;\n      padding: 0 7px !important;\n      // white-space: inherit !important;\n\n      &:first-child {\n        border-left: none !important;\n      }\n\n      &:last-child {\n        border-right: none !important;\n      }\n\n      .active-status {\n        background-color: #dfebff;\n        color: #003da5;\n      }\n\n      .not-started-status {\n        background-color: #f1f1f1;\n        color: #595959;\n      }\n\n      .completed-status {\n        background-color: #e6ffe8;\n        color: #006f05;\n      }\n    }\n\n    .p-inputtext {\n      border-radius: 50px;\n    }\n  }\n\n  .actions {\n    padding-left: 20px;\n  }\n\n  .p-datatable .p-datatable-footer {\n    background: white;\n    border: 0;\n    border-width: 0;\n    padding: 1rem 1rem;\n    font-weight: 300;\n    padding: 0;\n  }\n\n  .artWorkStatusFooter-class {\n    //position: absolute;\n    width: 100%;\n  }\n\n  .artWorkStatusFooter-class ::-webkit-scrollbar {\n    width: 0px !important;\n    height: 0%;\n    background: transparent;\n  }\n\n  .p-datatable > .p-datatable-wrapper {\n    overflow: auto;\n    height: calc(100% - 140px);\n    width: 100%;\n\n    @media only screen and (max-width: 1024px) {\n      height: calc(100% - 200px);\n    }\n  }\n  //adjust the height after adding the pagination for special project\n  #special-project > .p-datatable-wrapper {\n    overflow: auto;\n    height: calc(100% - 100px);\n    width: 100%;\n    \n    @media only screen and (max-width: 1024px) {\n      height: calc(100% - 200px);\n    }\n  }\n\n  .p-datatable-scrollable-body {\n    overflow: auto;\n    /* This is to hide the default DataTable scrollbar */\n  }\n\n  .p-datatable-table {\n    line-height: 12px;\n    width: 122%;\n  }\n\n  .p-column-title {\n    font-weight: $fontWeight400;\n\n    span {\n      font-size: 12px;\n      margin-left: 2px;\n      align-items: center;\n    }\n  }\n\n  .p-datatable-tbody {\n    font-weight: $fontWeight400;\n  }\n\n  // th:after,\n  // td:after {\n  //   content: '';\n  //   display: block;\n  //   height: 22px;\n  //   width: 0.8px;\n  //   background-color: #acacac;\n  //   position: absolute;\n  //   top: 25%;\n  //   right: 0;\n  // }\n\n  td,\n  table .p-datatable .p-datatable-tbody > tr > td,\n  th,\n  tr {\n    position: relative;\n    // border: 0 !important;\n  }\n\n  &.dsbp-wrapper {\n    .p-datatable {\n      height: calc(100% - 220px);\n    }\n  }\n}\n\n.font-bold {\n  font-weight: 700;\n}\n\n.p-checkbox {\n  margin: 8px 8px 8px 8px;\n}\n\n.p-checkbox-checked + label {\n  color: #003da5;\n}\n\n.ml-2 {\n  font-weight: $fontWeight400;\n  font-size: 14px;\n  line-height: 17px;\n}\n\n// Filter and Save buttons disabled\nimg[disabled] {\n  opacity: 0.5;\n  cursor: no-drop;\n}\n\n// ArtworkStatusList Styles End\n\n// ConfirmationPopUp Styles Start\n.clearAllFilterMainDiv {\n  display: flex;\n  padding: 10.56px 22px 22px 2px;\n}\n\n.clearAllFilterDiv {\n  line-height: 12px;\n  justify-items: end;\n  display: flex;\n  position: absolute;\n  right: 22px;\n  top: 18px;\n}\n\n.clearAllFilter {\n  cursor: pointer;\n}\n\n.clearAllFilterIcon {\n  cursor: pointer;\n  position: absolute;\n  right: 5px;\n}\n\n.sortAndFrozen {\n  padding: 0 22px 22px 2px;\n  cursor: pointer;\n  line-height: 12px;\n}\n\n.multiSelect {\n  cursor: pointer;\n  line-height: 10px;\n\n  .p-placeholder {\n    color: #595959 !important;\n  }\n\n  .p-multiselect {\n    width: 124px !important;\n  }\n}\n\n.p-overlaypanel {\n  position: absolute !important;\n}\n\n.p-multiselect-item {\n  text-wrap: wrap;\n  font-size: 10px !important;\n  line-height: 12px !important;\n  padding: 0px 0 !important;\n}\n\n.p-inputtext {\n  font-size: 10px !important;\n  line-height: 12px !important;\n  font-family: Montserrat !important;\n}\n\n// Container header section\n.action-button {\n  border-radius: 20px;\n  box-shadow: 0 0 0 1px #003da5;\n}\n\n.p-dropdown-item:hover {\n  background-color: #edf4fa !important;\n}\n\ndiv.actions-right {\n  display: flex;\n  flex-direction: row;\n\n  &:nth-child(2) {\n    margin-left: 12px;\n  }\n}\n\n.justify-content-center,\n.justify-content-center1 {\n  border: none;\n}\n\n.justify-content-center1 {\n  margin-left: 15px;\n}\n\ndiv.p-button.p-component:nth-child(1) {\n  border-radius: 12px 0 0 12px;\n}\n\ndiv.p-button.p-component:nth-child(2) {\n  background-color: #acacac !important;\n  color: white !important;\n  border-radius: 0 12px 12px 0;\n}\n\ndiv.p-selectbutton.p-buttonset.p-component {\n  border: none;\n}\n\n.p-selectbutton .p-button.p-highlight {\n  border-color: grey !important;\n}\n\n.p-selectbutton .p-button {\n  border-color: grey;\n}\n\n.apply-filter-text {\n  color: \"#003DA5\" !important;\n}\n\n.filter-color-change {\n  filter: invert(10%) sepia(100%) saturate(1200%) hue-rotate(204deg) brightness(60%) contrast(135%);\n}\n\n.checkbox-columnnames {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n\n  label {\n    margin-bottom: 0px;\n    margin-top: 3px;\n  }\n}\n\n.clearfix::after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n#tasksActions {\n  background: #003da5;\n  font-size: 12px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  border-radius: 20px;\n  border: 0;\n  margin: 0;\n}\n\n.dropdown {\n  background: transparent;\n  font-size: 12px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  border-radius: 20px;\n  border: 0;\n\n  &:focus-visible {\n    outline: none;\n  }\n}\n\n.dropdown-item {\n  font-size: 12px;\n  padding: 11px 16px;\n  color: #595959;\n\n  &:hover:last-child {\n    border-radius: 0 0 8px 8px;\n  }\n\n  &:hover:first-child {\n    border-radius: 8px 8px 0 0;\n  }\n\n  &.active,\n  &:hover {\n    background: #edf4fa !important;\n    color: #003da5;\n  }\n\n  &:focus {\n    outline: none;\n  }\n}\n\n.artwork-dsbp {\n  .dropdown-item {\n    @extend .dropdown-item;\n\n    &.active,\n    &:hover {\n      background: #edf4fa !important;\n      color: #003da5;\n    }\n  }\n}\n\n.dropdown-menu {\n  padding: 0;\n}\n\n#tasksInActive {\n  background-color: #fff !important;\n  border-color: #003da5 !important;\n  color: #003da5 !important;\n  opacity: 1;\n}\n\n.dropdown-button-custom #tasksInActive::after {\n  content: \"\";\n  display: inline-block;\n  width: 12px;\n  height: 8px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8' fill='none'%3E%3Cpath d='M10 2L6.70707 5.2929C6.31818 5.68179 5.68182 5.68179 5.29293 5.2929L2 2' stroke='%23003DA5' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  border: 0;\n}\n\n.dropdown-button-custom .btn[aria-expanded=\"true\"]::after,\n.dropdown-button-custom .btn[aria-expanded=\"false\"]::after {\n  content: \"\";\n  display: inline-block;\n  width: 12px;\n  height: 8px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8' fill='none'%3E%3Cpath d='M2 6L5.29293 2.7071C5.68182 2.31821 6.31818 2.31821 6.70707 2.7071L10 6' stroke='white' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  border: 0;\n  transform: rotate(0deg);\n}\n\n.dropdown-button-custom .btn[aria-expanded=\"false\"]::after {\n  transform: rotate(180deg);\n}\n\n.footerIcons {\n  tab-size: 10px;\n  color: #818085;\n  position: relative;\n  background: #ffffff;\n  left: 0;\n  display: flex;\n  border-top: 1px solid black;\n\n  .pi-times {\n    position: relative !important;\n    width: 14px;\n    height: 14px;\n    right: 0 !important;\n    top: 0 !important;\n    cursor: auto !important;\n  }\n}\n\n// ---- footerIcon Styles start-----//\n.recordfooter {\n  display: flex;\n  justify-content: space-between;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.footerIcon {\n  display: flex;\n  flex-direction: row;\n}\n\n.footIcon {\n  border-left: 1px solid;\n  padding-left: 4px;\n  &:first-child {\n    border-left: unset;\n  }\n}\n\n.footerIconAll {\n  font-size: 16px;\n}\n\n.footerIconsMain {\n  display: flex;\n  align-items: center;\n\n  &:first-child {\n    margin-left: 0;\n  }\n}\n\n.footerIcons2 {\n  color: #ff0000;\n  rotate: 180deg;\n}\n\n.footerIcons3 {\n  color: #01ff1a;\n}\n\n.footerIcons4 {\n  color: #ff0000;\n  margin-right: 10px;\n}\n\n.footerIcons5 {\n  color: #01ff1a;\n}\n\n.footerIcons6 {\n  color: red;\n}\n\n.footerIcons7 {\n  color: gray;\n}\n\n.footerIcons8 {\n  color: #01ff1a;\n}\n\n.footerIcons9 {\n  color: #ff0000;\n}\n\n.footerIcons10 {\n  font-weight: bold;\n  color: black;\n}\n\n.footerIcons11 {\n  font-weight: bold;\n  color: black;\n}\n\n.footerIconsContent1 {\n  font-weight: 500;\n  line-height: 12.19px;\n  padding: 0 5px;\n  margin: 0px 4px 0px 4px;\n  // border-right: 1px solid;\n  font-size: 8px;\n  color: black;\n}\n\n.pi pi-circle-off {\n  font-size: 16px;\n  margin-top: 10px;\n}\n\n// .p-datatable .p-column-header-content {\n//   display: block;\n// }\n.col-header {\n  text-align: center !important;\n  color: #003da5 !important;\n  background: #edf4fa !important;\n}\n\n// ---- footerIcon Styles end-----//\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
